export default {
      id: "employe-usage",
      viewBox: "0 0 9 9",
      url: __webpack_public_path__ + "img/icons.svg#employe",
      toString: function () {
        return this.url;
      }
    }